import { api } from "../../utils/api"

export const postDocumentsContract = async (data) => {
  try{
    const response = await api.post(`documents`, data);
    return response;
  } catch (err){
    throw new Error(err);
  } 
}
